export default __webpack_public_path__ + "locales/sl/Common.json?hash=55dbc26afdb0ea7f2f64c07cd97d2805";